import { jsx as _jsx } from "react/jsx-runtime";
import "./NoDataAvailable.scss";
import { useTranslation } from "react-i18next";
const NoDataAvailable = ({ minHeight = 0 }) => {
    const { t } = useTranslation();
    return (_jsx("div", { className: "no-data-available", style: { minHeight: `${minHeight}px` }, children: _jsx("p", { children: t("noDataAvailable") }) }));
};
export default NoDataAvailable;
